import React from 'react';
import {withStyles} from '@material-ui/core';
import i18n from '../../i18n';
import Paper from '@material-ui/core/Paper/Paper';
import List from '@material-ui/core/List/List';
import ListItem from '@material-ui/core/ListItem/ListItem';
import Grid from '@material-ui/core/Grid/Grid';
import FormaterDate from '../Formater/Date';
import RenderDetailsRow from '../Formater/RenderDetailsRow';
import FormaterCurrency from '../Formater/Currency';
import {cleanPhone, setNameWithLabel} from '../Form/utils';
import moment from "moment";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography/Typography";
import PreviewButton from "../File/PreviewButton";
import LinkIconButton from "../Formater/LinkIconButton";
import iconNames from "../Formater/IconNames";
import EllipsisWithTooltip from "../Formater/EllipsisWithTooltip";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import ContractBuildingsTable from "./Tables/ContractBuildingsTable";
import DocumentsTable from "../Media/Documents/DocumentsTable";

const renderDetailsRow = (label, value, classes) => {
    return (
        <ListItem key={Math.random()} dense className={classes.detailsRow}>
            <Grid container spacing={24}>
                <Grid item xs={4}>
                    <Typography
                        className={classes.detailsLabel}
                        component={'div'}
                        variant={'subtitle2'}>
                        {(<EllipsisWithTooltip>{label}</EllipsisWithTooltip>)}
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography
                        className={classes.detailsValue}
                        component={'div'}
                        variant={'body2'}>
                        {value}
                    </Typography>
                </Grid>
            </Grid>
        </ListItem>
    );
};

const dateFormat = (date,format) => moment( date ,'YYYY-MM-DD HH:mm:ss').format(format)

const ContractDetails = (props) => {

    const {
        contract,
        files,
        classes
    } = props;

    const dateOfContract = contract.date_of_contract && dateFormat(contract.warranty_period_start,'DD.MM.YYYY');
    const warrantyPeriodStart = contract.warranty_period_start && dateFormat(contract.warranty_period_start,'DD.MM.YYYY');
    const warrantyPeriodEnd = contract.warranty_period_end && dateFormat(contract.warranty_period_end,'DD.MM.YYYY');
    const userName = contract.user && contract.user.name;

    const openDeficiencies = 0;
    const defectsEliminated = 0;
    const orderWithdrawal = 0;

    return (
        <React.Fragment>
            <Grid container spacing={24} className={classes.vSpace}>
                <Grid item xs={12} md={6}>
                    <Paper className={classes.spaces} style={{height:'100%'}}>
                        <div className={classes.details}>
                            <List className={classes.fullWidth}>
                                {contract.building && (
                                    <RenderDetailsRow label={i18n.get('contract.construction_project')} value={ contract.building.name }>
                                        <LinkIconButton
                                            text={contract.building.name}
                                            href={`/construction/${contract.building.id}`}
                                            icon={iconNames.building}
                                        />
                                    </RenderDetailsRow>
                                )}
                                {contract.contact && (
                                    <RenderDetailsRow label={i18n.get('contract.form.subcontractor')} value={ contract.contact.company_name }>
                                        <LinkIconButton
                                            text={contract.contact.company_name}
                                            href={`/contacts/craft/${contract.contact.id}`}
                                            icon={iconNames.company}
                                        />
                                    </RenderDetailsRow>
                                )}
                                {dateOfContract && renderDetailsRow(i18n.get('contract.dates.contract_conclusion'), dateOfContract ,classes)}
                                {/*
                                {warrantyPeriodStart && renderDetailsRow(i18n.get('contract.dates.warranty_period_start'), warrantyPeriodStart ,classes)}
                                {warrantyPeriodEnd && renderDetailsRow(i18n.get('contract.dates.warranty_period_end'), warrantyPeriodEnd ,classes)}
                                */}
                            </List>
                        </div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Paper className={classes.spaces} style={{height:'100%'}}>
                        <div className={classes.details}>
                            <List className={classes.fullWidth}>
                                {/*
                                {openDeficiencies >= 0 && renderDetailsRow(i18n.get('contract.open_deficiencies'),openDeficiencies, classes)}
                                {defectsEliminated >= 0 && renderDetailsRow(i18n.get('contract.defects_eliminated'),defectsEliminated, classes)}
                                {orderWithdrawal >= 0 && renderDetailsRow(i18n.get('contract.order_withdrawal'),orderWithdrawal, classes)}
                                */}
                                {warrantyPeriodStart && renderDetailsRow(i18n.get('contract.dates.warranty_period_start'), warrantyPeriodStart ,classes)}
                                {warrantyPeriodEnd && renderDetailsRow(i18n.get('contract.dates.warranty_period_end'), warrantyPeriodEnd ,classes)}
                                {userName && renderDetailsRow(i18n.get('contract.editor'), userName ,classes)}

                            </List>
                        </div>
                    </Paper>
                </Grid>

                <Grid item xs={12}>
                    <Paper className={classes.spaces}>
                        <Grid container spacing={24} direction={'row'} alignItems={'flex-start'}>
                            <Grid item xs>
                                <Typography variant="h6" color={"primary"}>{i18n.get('contract.form.building')}</Typography>
                            </Grid>
                            {/*<Grid item xs align={'right'}>
                                <Button
                                    size={"small"}
                                    component={'a'}
                                    variant={"contained"}
                                    type={'button'}
                                    color={"primary"}
                                    //onClick={openDialog}
                                >
                                    <Icon fontSize="small">add</Icon>
                                    &nbsp;
                                    {i18n.get('contract.add_building')}
                                </Button>
                            </Grid>*/}
                        </Grid>
                        {contract.buildings && contract.buildings.length > 0 ? (
                            <ContractBuildingsTable contract={contract} />
                        ): ( <div>{i18n.get('default.empty')}</div> )}
                    </Paper>
                </Grid>

                <Grid item xs={12}>
                    <Paper className={classes.spaces}>
                        <Grid container spacing={24} direction={'row'} alignItems={'flex-start'}>
                            <Grid item xs>
                                <Typography variant="h6" color={"primary"}>{i18n.get('contract.documents')}</Typography>
                            </Grid>
                            {/*
                            <Grid item xs align={'right'}>
                                <Button
                                    size={"small"}
                                    component={'a'}
                                    variant={"contained"}
                                    type={'button'}
                                    color={"primary"}
                                    //onClick={openDialog}
                                >
                                    <Icon fontSize="small">add</Icon>
                                    &nbsp;
                                    {i18n.get('contract.upload_file')}
                                </Button>
                            </Grid>
                            */}
                        </Grid>
                        {files && files.length > 0 ? (
                            <DocumentsTable entity={{label:'contract_id', id: contract.id }} files={files} />
                        ): ( <div>{i18n.get('default.empty')}</div> )}
                    </Paper>
                </Grid>{/**/}
            </Grid>
        </React.Fragment>
    );
}

const styles = theme => ({
    previewIcon: {
        textAlign: 'center',
    },
    spaces: {
        padding: theme.spacing.unit * 1.5,
    },
    vSpace: {
        marginTop: theme.spacing.unit * 1.5,
        marginBottom: theme.spacing.unit * 1.5,
    },
    fullWidth: {
        width: '100%',
    },
    details: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        '&:last-child': {
            padding: 0,
        },
    },
    detailsLabel: {
        textAlign: 'right',
    },
    detailsValue: {
        '& > *': {
            ...theme.helpers.oneLiner,
        },
    },
});

export default withStyles(styles)(ContractDetails);
